import React from 'react';
import Link from '../common/TrackedLink';
import {pushSearchResultsItem} from "../../utils/datalayer";

const UrlSiteSearch = ({ url, keyword }) => {
	// console.log("UrlSiteSearch")
	// console.dir(url);
	return (
		<li className="results-list-item">
			<div>
				<h2>{url.title}</h2>
				<Link
					className="arrow-link"
					to={`${url.url}`}
					onClick={(e) => {pushSearchResultsItem(e, keyword)}}>View more</Link>
			</div>
		</li>
	);
};

export default UrlSiteSearch;


// WEBPACK FOOTER //
// ./src/pages/sitesearch/UrlSiteSearch.js